import React, { useContext, useState, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import FilterPanel from '@components/FilterPanel';
import I18n from '@utils/i18n';
import useTimeZoneContext from '@contexts/useTimeZoneContext';
import useTenantContext from '@contexts/useTenantContext';
import TimeZoneDropdown from '@components/Dropdowns/TimeZoneDropdown';
import Statuses from './Statuses';
import View from './View';
import CreateEvent from '../CreateEvent';
import { CalendarContext } from '../../CalendarContext';
import useFilters from '../../hooks/useFilters';
import AssigneeMultiSelect from '../../../../components/Multiselects/AssigneeMultiselect/index';
const kendoCacheKey = 'kendo/calendar';
function Header() {
    var _a;
    const { actions: { onResetFilters, setTechnicians, setSubcontractors, setIncludeInactiveTechs }, includeInactiveTechs, inactiveTechniciansForSelect, state: { loading, selectedTechnicianIds, selectedSubcontractorIds, filters: { values: filterValuesState } } } = useContext(CalendarContext);
    // Build ITechnician stubs from the inactive SelectOptions so that AssigneeMultiSelect
    // can display them in the dropdown without touching the internal technicians API.
    const extraInactiveTechnicians = useMemo(() => {
        if (!includeInactiveTechs)
            return [];
        return inactiveTechniciansForSelect.map((opt) => ({
            id: Number(opt.value),
            name: String(opt.label),
            color: '#666666',
            photoUrl: null,
            fleetManagerVehicleId: 0
        }));
    }, [includeInactiveTechs, inactiveTechniciansForSelect]);
    const { timezone, setTimeZone, timeZonesForSelect } = useTimeZoneContext();
    const { tenant } = useTenantContext();
    const [timeZoneToolbarContainer, setTimeZoneToolbarContainer] = useState(null);
    const onResetCache = () => {
        // eslint-disable-next-line no-restricted-globals, no-alert, @typescript-eslint/no-unsafe-argument
        if (!confirm(I18n.t('generic.are_you_sure')))
            return;
        localStorage.removeItem(kendoCacheKey);
        window.location.reload();
    };
    useEffect(() => {
        var _a;
        if (!timeZoneToolbarContainer && ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.flags) === null || _a === void 0 ? void 0 : _a.hasMultiTimezone)) {
            const toolbarChunk = document.querySelector('.fc-header-toolbar .fc-toolbar-chunk:last-child');
            if (toolbarChunk) {
                const timeZoneContainer = document.createElement('div');
                timeZoneContainer.className = 'fc-button-group';
                timeZoneContainer.id = 'time-zone-button-group';
                toolbarChunk.appendChild(timeZoneContainer);
                setTimeZoneToolbarContainer(timeZoneContainer);
            }
        }
    }, [timeZoneToolbarContainer, (_a = tenant === null || tenant === void 0 ? void 0 : tenant.flags) === null || _a === void 0 ? void 0 : _a.hasMultiTimezone]);
    const filters = useFilters();
    const style = loading ? { pointerEvents: 'none', top: '0' } : { top: '0' };
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterPanel, { onResetFilters: onResetFilters, onResetCache: onResetCache, filters: filters }),
        React.createElement("div", { className: "qmb-actions--sticky", style: style },
            React.createElement("div", { className: "actions__group--flex" },
                React.createElement(CreateEvent, { withTitle: true }),
                React.createElement(AssigneeMultiSelect
                // eslint-disable-next-line react/style-prop-object
                , { 
                    // eslint-disable-next-line react/style-prop-object
                    style: "default", 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    teamIds: filterValuesState.technicianTeam, 
                    // Handle residual 'all' string in legacy localStorage caches
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    selectedTechnicianIds: selectedTechnicianIds === 'all' ? [] : selectedTechnicianIds, onTechChange: (selections) => {
                        setTechnicians(selections);
                    }, 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    selectedSubcontractorIds: selectedSubcontractorIds === 'all' ? [] : selectedSubcontractorIds, onSubChange: (selections) => {
                        setSubcontractors(selections);
                    }, extraTechnicians: extraInactiveTechnicians, includeInactive: includeInactiveTechs, onIncludeInactiveChange: setIncludeInactiveTechs }),
                React.createElement(Statuses, null)),
            React.createElement("div", { className: "actions__group" },
                React.createElement(View, null))),
        timeZoneToolbarContainer &&
            createPortal(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            React.createElement(TimeZoneDropdown, { timeZoneList: timeZonesForSelect, selectedValue: timezone, onChange: setTimeZone }), timeZoneToolbarContainer)));
}
export default Header;
